import { vaderAPIService } from './index'
import store from '../store'

export default {
  getCategories: () => vaderAPIService({
    url: 'filters/categories',
    method: 'get',
  }),
  getBrands: (keywords) => {
    const params = {
      keywords,
      size: 100,
    }
    return vaderAPIService({
      url: 'filters/all/brands',
      method: 'get',
      params,
    })
  },
  getStores: (keywords) => {
    const params = {
      keywords,
      size: 100,
    }
    return vaderAPIService({
      url: 'filters/all/stores',
      method: 'get',
      params,
    })
  },
  getProductById: (productId, params) => vaderAPIService({
    url: `products/${productId}`,
    params,
  }),
  getProductByFilter: (params) => vaderAPIService({
    url: `products`,
    params,
  }),
  getProductByStoreSku: ({ storeId, skuId }) => {
    const params = {
      store_id: storeId,
      sku_id: skuId,
    }
    const token = store.getters['user/token']
    const headers = {
      Authorization: token,
    }
    return vaderAPIService({
      url: 'products/sku',
      method: 'get',
      params,
      headers,
    })
  },
}
